import { render, staticRenderFns } from "./SupportComponent.vue?vue&type=template&id=74b76908&scoped=true"
import script from "./SupportComponent.vue?vue&type=script&lang=js"
export * from "./SupportComponent.vue?vue&type=script&lang=js"
import style0 from "./SupportComponent.vue?vue&type=style&index=0&id=74b76908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b76908",
  null
  
)

export default component.exports